<template>
  <v-dialog v-model="localDialog" width="70%" @update:modelValue="updateDialog" transition="" persistent :open-delay="0"
    :close-delay="0">
    <v-card>
      <v-card-title class="text-h6">
        <span>Upload Document</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="CategorySetup">
          <v-row>
            <v-col cols="12" md="7">
              <v-autocomplete
                variant="outlined"
                density="compact"
                v-model="project_id.value.value"
                :items="getProjectList"
                :item-title="  (item) => `${item.project_title} - ${item.code}` "
                item-value="id"
                autocomplete="off"
                :error-messages="project_id.errorMessage.value"
                hide-details="auto"
                clearable
              >
                <template #label>
                  Project <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>
              </v-col>

            <v-col cols="12" md="5">
              <v-autocomplete
                variant="outlined"
                density="compact"
                v-model="folder_id.value.value"
                :items="getCmsFoldersList"
                :item-title="  (item) => `${item.name}` "
                item-value="id"
                autocomplete="off"
                :error-messages="folder_id.errorMessage.value"
                hide-details="auto"
                clearable
              >
                <template #label>
                  Folder <span class="text-red-accent-4">*</span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="7">
              <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete 
                    variant="outlined"
                    density="compact"
                    v-model="contract.value.value"
                    :items="appendix.contracts"
                    :item-title="(item) => `${item.label}`"
                    item-value="value" 
                    autocomplete="off" 
                    :error-messages="contract.errorMessage.value"
                    hide-details="auto"
                    clearable
                  >
                    <template #label>
                      Contract <span class="text-red-accent-4">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    variant="outlined"
                    density="compact" 
                    v-model="subcomponent.value.value" 
                    :items="appendix.subcomponents"
                    :item-title="(item) => `${item.label}`"
                    item-value="value"
                    autocomplete="off"
                    :error-messages="subcomponent.errorMessage.value"
                    hide-details="auto"
                    clearable>
                      <template #label>
                        Sub-Component <span class="text-red-accent-4">*</span>
                      </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                  variant="outlined" 
                  density="compact" 
                  v-model="area.value.value"
                  :items="appendix.areas"
                  :item-title="(item) => `${item.label}`"
                  item-value="value"
                  autocomplete="off" 
                  :error-messages="area.errorMessage.value"
                  hide-details="auto"
                  clearable>
                  <template #label>
                    <!-- :disabled="props.isEditMode" -->
                    Area <span class="text-red-accent-4">*</span>
                  </template>
                </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    v-model="discipline.value.value" 
                    :items="appendix.disciplines" 
                    :item-title="(item) => `${item.label}`"
                    item-value="value"
                    autocomplete="off"
                    :error-messages="discipline.errorMessage.value"
                    hide-details="auto"
                    clearable>
                      <template #label>
                        Discipline <span class="text-red-accent-4">*</span>
                      </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete 
                    variant="outlined" 
                    density="compact" 
                    v-model="doctype.value.value" 
                    :items="appendix.documenttypes" 
                    :item-title="(item) => `${item.label}`"
                    item-value="value" 
                    autocomplete="off" 
                    :error-messages="doctype.errorMessage.value" 
                    hide-details="auto"
                    clearable>
                      <template #label>
                        Document Type <span class="text-red-accent-4">*</span>
                      </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="4">
                  <v-autocomplete 
                    variant="outlined" 
                    density="compact" 
                    v-model="revision.value.value" 
                    :items="appendix.revisions" 
                    :item-title="(item) => `${item.label}`"
                    item-value="value" 
                    autocomplete="off" 
                    :error-messages="revision.errorMessage.value" 
                    hide-details="auto"
                    clearable>
                      <template #label>
                        Revision <span class="text-red-accent-4">*</span>
                      </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-col>

             <v-col cols="12" md="5">
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="title.value.value"
                    label="Document Title"
                    variant="outlined"
                    density="compact"
                    :error-messages="title.errorMessage.value"
                    autocomplete="off"
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-date-input
                    prepend-icon=""
                    prepend-inner-icon="mdi-calendar"
                    density="compact"
                    variant="outlined"
                    class=""
                    v-model="document_date.value.value"
                    autocomplete="off"
                    hide-details="auto"
                    clearable
                    :error-messages="document_date.errorMessage.value"
                    >
                    <template #label>
                        Document Date
                        <span class="text-red-accent-4">*</span>
                    </template>
                  </v-date-input>                
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="7">
              <v-file-input 
                v-model="main_file.value.value" 
                label="Attachment" 
                variant="outlined" 
                density="compact"
                single-line
                show-size 
                autocomplete="off" 
                prepend-icon="" 
                prepend-inner-icon="mdi-paperclip"
                :error-messages="main_file.errorMessage.value" 
                hide-details="auto">
                <template #label>
                  Attachment
                  <span v-if="!props.isEditMode" class="text-red-accent-4">*</span>
                </template>
              </v-file-input>
            </v-col>

            <v-col cols="12" md="5">
              <!-- File Input -->
              <v-file-input
                v-model="supporting_attachment.value.value" 
                label="Supporting Attachment(Optional)"
                variant="outlined" 
                density="compact" 
                single-line
                show-size 
                autocomplete="off" 
                hide-details="auto" 
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                multiple
              >
              </v-file-input>
            </v-col>

              <v-col cols="12">
                <v-textarea
                 label="Remarks (Optional)" 
                 density="compact" 
                 variant="outlined" 
                 autocomplete="off" 
                 v-model="remarks.value.value" 
                 :error-messages="remarks.errorMessage.value"
                 hide-details="auto" 
                 clearable>
                </v-textarea>
              </v-col>

              <!-- File Preview Section for Edit Mode -->
              <v-col cols="12" v-if="props.isEditMode && documentData">
                <v-card variant="outlined">
                  <v-card-title class="text-subtitle-1">Current Files Preview</v-card-title>
                  <v-card-text>
                    <!-- Main File Preview -->
                    <div v-if="documentData.path" class="mb-4">
                      <h4 class="text-h6 mb-2">Main File: {{ documentData.original_name }}</h4>
                      <div class="d-flex align-center">
                        <v-btn 
                          icon="mdi-eye" 
                          size="small" 
                          variant="text" 
                          :href="fileServerUrl + documentData.path" 
                          target="_blank"
                          class="mr-2"
                        ></v-btn>
                        <span class="text-caption">{{ formatFileSize(documentData.size) }}</span>
                      </div>
                      <!-- Image Preview -->
                      <div v-if="isImage(documentData.mime_type)" class="mt-2">
                        <img 
                          :src="fileServerUrl + documentData.path" 
                          style="max-width: 300px; max-height: 200px; border: 1px solid #ddd;" 
                          alt="Main file preview"
                        />
                      </div>
                      <!-- PDF Preview -->
                      <div v-else-if="isPdf(documentData.mime_type)" class="mt-2">
                        <iframe 
                          :src="fileServerUrl + documentData.path" 
                          width="400" 
                          height="300" 
                          style="border: 1px solid #ddd;"
                        ></iframe>
                      </div>
                      <!-- Other files: just show download link -->
                      <div v-else class="mt-2">
                        <v-btn 
                          variant="outlined" 
                          size="small" 
                          :href="fileServerUrl + documentData.path" 
                          target="_blank"
                        >
                          Download File
                        </v-btn>
                      </div>
                    </div>

                    <!-- Supporting Files Preview -->
                    <div v-if="documentData.supportingFiles && documentData.supportingFiles.length">
                      <h4 class="text-h6 mb-2">Supporting Files:</h4>
                      <div v-for="file in documentData.supportingFiles" :key="file.id" class="mb-3 pa-2 border">
                        <div class="d-flex align-center mb-1">
                          <span class="font-weight-medium">{{ file.original_name }}</span>
                          <v-spacer></v-spacer>
                          <v-btn 
                            icon="mdi-eye" 
                            size="small" 
                            variant="text" 
                            :href="fileServerUrl + file.path" 
                            target="_blank"
                            class="mr-2"
                          ></v-btn>
                          <span class="text-caption">{{ formatFileSize(file.size) }}</span>
                        </div>
                        <!-- Image Preview -->
                        <div v-if="isImage(file.mime_type)" class="mt-2">
                          <img 
                            :src="fileServerUrl + file.path" 
                            style="max-width: 200px; max-height: 150px; border: 1px solid #ddd;" 
                            alt="Supporting file preview"
                          />
                        </div>
                        <!-- PDF Preview -->
                        <div v-else-if="isPdf(file.mime_type)" class="mt-2">
                          <iframe 
                            :src="fileServerUrl + file.path" 
                            width="300" 
                            height="200" 
                            style="border: 1px solid #ddd;"
                          ></iframe>
                        </div>
                        <!-- Other files: just show download link -->
                        <div v-else class="mt-2">
                          <v-btn 
                            variant="outlined" 
                            size="small" 
                            :href="fileServerUrl + file.path" 
                            target="_blank"
                          >
                            Download File
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
          </v-row>

          <input type="text" v-model="document_id.value.value" hidden>

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn class="bg-red" variant="flat" type="reset" @click="closeDialog">Close</v-btn>
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                {{ props.isEditMode ? "Update" : "Save" }}
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { fileServerUrl, prefix } from "@/store/api";
import formattedDate from "@/plugins/dateFormatter";
import axios from "axios";

export default {
  name: "CmsDocumentUploadModal",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    documentData: {
      type: Object,
      default: () => ({
        id: null,
        code: "",
        remarks: "",
        project_id: null,
        folder_id: null,
        title: "",
        contract: null,
        subcomponent: null,
        area: null,
        discipline: null,
        doctype: null,
        revision: null,
        main_file: null,
        document_date: null,
        supporting_attachment: null,
        document_id: null
      }),
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: "",
      loading: false,
      appendix: {
        areas: [],
        contracts: [],
        disciplines: [],
        documenttypes: [],
        revisions: [],
        subcomponents: []
      }
    };
  },
  computed: {
    // getContractsList() {
    //   return this.$store.getters['cmsAppendix/getContractsList'] || [];
    // },
    // getSubcomponentsList() {
    //   return this.$store.getters['cmsAppendix/getSubcomponentsList'] || [];
    // },
    // getAreasList() {
    //   return this.$store.getters['cmsAppendix/getAreasList'] || [];
    // },
    // getDisciplinesList() {
    //   return this.$store.getters['cmsAppendix/getDisciplinesList'] || [];
    // },
    // getDocumentTypesList() {
    //   return this.$store.getters['cmsAppendix/getDocumentTypesList'] || [];
    // },
    // getRevisionsList() {
    //   return this.$store.getters['cmsAppendix/getRevisionsList'] || [];
    // },

    getProjectList() {
      return this.$store.getters.getProjectList;
    },

    getCmsFoldersList() {
      return this.$store.getters.getCmsFoldersList;
    },
      
    getDocumentTypeList() {
      return [
        { value: 'pdf', label: 'PDF Document' },
        { value: 'doc', label: 'Word Document (.doc)' },
        { value: 'docx', label: 'Word Document (.docx)' },
        { value: 'xls', label: 'Excel File (.xls)' },
        { value: 'xlsx', label: 'Excel File (.xlsx)' },
        { value: 'csv', label: 'CSV File' },
        { value: 'ppt', label: 'PowerPoint (.ppt)' },
        { value: 'pptx', label: 'PowerPoint (.pptx)' },
        { value: 'jpg', label: 'JPEG Image' },
        { value: 'jpeg', label: 'JPEG Image' },
        { value: 'png', label: 'PNG Image' },
        { value: 'gif', label: 'GIF Image' },
        { value: 'txt', label: 'Text File' },
        { value: 'zip', label: 'ZIP Archive' }
      ];
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val;
      // Automatically select the latest project when dialog opens in non-edit mode
      if (val && !this.isEditMode) {
        this.autoSelectLatestProject();
      }
    },
    localDialog(val) {
      this.$emit("update:dialog", val);
    },
    documentData: {
      immediate: true,
      handler(newData) {
        if (!newData) return;

        if (this.resetForm) {
          this.resetForm({ errors: {}, touched: {} });
        }
        if (!this.props.isEditMode) {
          this.document_id.setValue(null, false);
        }
        
        if (this.project_id) this.project_id.setValue(newData.project_id || null, false);
        if (this.folder_id) this.folder_id.setValue(newData.folder_id || null, false);
        if (this.title) this.title.setValue(newData.title || "", false);
        if (this.contract) this.contract.setValue(newData.parsed_code.contract || null, false);
        if (this.subcomponent) this.subcomponent.setValue(newData.parsed_code.subcomponent || null, false);
        if (this.area) this.area.setValue(newData.parsed_code.area || null, false);
        if (this.discipline) this.discipline.setValue(newData.parsed_code.discipline || null, false);
        if (this.doctype) this.doctype.setValue(newData.parsed_code.doctype || null, false);
        if (this.revision) this.revision.setValue(newData.parsed_code.revision || null, false);
        if (this.document_date) this.document_date.setValue(newData.document_date || null, false);
        if (this.remarks) this.remarks.setValue(newData.remarks || "", false);
        if (this.document_id) this.document_id.setValue(newData.id || "", false);
      },
    },
  },
  created() {
    this.$store.dispatch("getCmsFoldersList");
    this.$store.dispatch("getProjectList");
  },
  methods: {
    updateDialog(val) {
      this.$emit("update:dialog", val);
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    autoSelectLatestProject() {
      const projectList = this.$store.getters.getProjectList;
      if (projectList && projectList.length > 0) {
        // Sort by id in descending order to get the latest project
        const latestProject = projectList.reduce((latest, current) => {
          return current.id > latest.id ? current : latest;
        });
        if (this.project_id) {
          this.project_id.setValue(latestProject.id, false);
        }
      }
    },
    loadJsonPatterns() {
      axios.get(`${prefix}cms/appendix/load-json-code-patterns`).then(response => {
        let data = response.data.data
        this.appendix = {
          areas: data.areas,
          contracts: data.contracts,
          disciplines: data.disciplines,
          documenttypes: data.documenttypes,
          revisions: data.revisions,
          subcomponents: data.subcomponents
        }
      }).catch(error => {
        console.error("Error loading JSON code patterns:", error);
      });
    },
    isImage(mimeType) {
      return mimeType && mimeType.startsWith('image/');
    },
    isPdf(mimeType) {
      return mimeType === 'application/pdf';
    },
    formatFileSize(bytes) {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
  },
  setup(props, { emit }) {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        project_id: yup.string().min(1).max(10).required().trim().label("Category"),
        contract: yup.string().required().label("Contract"),
        subcomponent: yup.string().required().label("Sub-Component"),
        area: yup.string().required().label("Area"),
        discipline: yup.string().required().label("Discipline"),
        doctype: yup.string().required().label("Doc Type"),
        revision: yup.string().required().label("Revision"),
        document_date: yup.date().required().label("Document Date"),
        main_file: yup.mixed().when('$isEditMode', {
          is: false,
          then: (schema) => schema.required('Main File is required'),
          otherwise: (schema) => schema.notRequired(),
        }),
        supporting_attachment: yup.mixed().nullable().label("Supporting Attachment"),
        project_id: yup.string().min(1).max(10).required().trim().label("Category"),
        folder_id: yup.string().min(1).max(10).required().trim().label("Folder"),
        title: yup.string().min(1).max(255).required().trim().label("Document Title"),
        remarks: yup.string().max(250).nullable().trim().label("Remarks"),
      }),
    });

    const project_id = useField("project_id");
    const folder_id = useField("folder_id"); 
    const title = useField("title");
    const contract = useField("contract");
    const subcomponent = useField("subcomponent");
    const area = useField("area");
    const discipline = useField("discipline");
    const doctype = useField("doctype");
    const revision = useField("revision");
    const document_date = useField("document_date");
    const main_file = useField("main_file");
    const supporting_attachment = useField("supporting_attachment");
    const remarks = useField("remarks");
    const document_id = useField("document_id");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const submit = handleSubmit((values) => {
      values.document_date = formattedDate(document_date.value.value);
      const formData = new FormData();
      

      if (props.isEditMode && props.documentData?.id) {
        formData.append("id", props.documentData.id);
      }

      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          if (key === 'supporting_attachment') {
            if (Array.isArray(values[key])) {
              values[key].forEach((file) => {
                formData.append('supporting_attachment[]', file);
              });
            } else if (values[key] instanceof File) {
               formData.append('supporting_attachment[]', values[key]);
            }
          } else if (key === 'main_file') {
            if (values[key] instanceof File) {
              formData.append(key, values[key]);
            }
          } else if (key == 'document_date') {
            formData.append(key, formattedDate(values[key]));
          }
          else {
            formData.append(key, values[key]);
          }
        } else {
          formData.append(key, '');
        }
      });

      store.dispatch("saveCmsDocuments", {
        formData,
        onProgress: (percent) => {
          console.log("Upload progress:", percent);
        }
      })
        .then((response) => {
          toast.success(response.data.message);
          loading.value = false;
          store.dispatch("getDocumentsList");
          emit("update:dialog", false);
          resetForm();
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Upload failed");
        });
    });
    

    return {
      submit,
      project_id,
      folder_id,
      contract,
      subcomponent,
      area,
      discipline,
      doctype,
      revision,
      title,
      document_date,
      main_file,
      supporting_attachment,
      remarks,
      document_id,
      resetForm,
      loading,
      errorMessages,
      props,
      fileServerUrl,
    };
  },
  mounted() {
    if (this.document_date?.value) {
      this.document_date.value.value = new Date();
    }
    this.loadJsonPatterns();
    // console.log(this.document_id.value.value);
  },
};
</script>
